import Component from './SsmsTable';
import createRenderer from './SsmsTable.relay';
export default createRenderer(Component);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/SsmsTable/index.js